module.exports = __webpack_public_path__ + "img/Sharp Edges.8b5ef94b.png";